import {
  Icon,
  Icon16Props,
  Icon20Props,
  styled,
  Text,
} from '@zeiss/beyond-online-react';
import { useBreakpoint } from '@zeiss/lib-helpers';

import { StyledContainer } from 'src/types';

const AlertTextContainer = styled.div<StyledContainer>`
  display: flex;
  gap: ${({ $isMinTablet }) =>
    /* istanbul ignore next -- @preserve */
    $isMinTablet ? 'var(--spacing-s)' : 'var(--spacing-xs)'};
  margin-top: ${({ $isMinTablet }) =>
    /* istanbul ignore next -- @preserve */
    $isMinTablet ? 'var(--spacing-m)' : 'var(--spacing-s)'};

  & > p {
    margin: 0;
    font: ${({ $isMinTablet }) =>
      /* istanbul ignore next -- @preserve */
      $isMinTablet ? 'var(--text-body-l)' : 'var(--text-body-m)'};
    color: var(--color-global-text-error);
  }

  & > svg {
    flex-shrink: 0;
    padding: 8px 0;
    color: var(--color-global-text-error);
  }
`;

interface AlertTextProps {
  icon: Icon16Props['icon'] | Icon20Props['icon'];
  text: string;
}
export const AlertText = ({ icon, text }: AlertTextProps) => {
  const isMinTablet = useBreakpoint('tablet');
  return (
    <AlertTextContainer $isMinTablet={isMinTablet}>
      {isMinTablet ? (
        <Icon icon={icon as Icon20Props['icon']} size={20} />
      ) : (
        <Icon icon={icon as Icon16Props['icon']} size={16} />
      )}
      <Text>{text}</Text>
    </AlertTextContainer>
  );
};
